import type { MetricDirectoryEntryResource as MetricDirectoryEntry } from "@/types_api/backend/transport/list_metric_directory_response"
import type { MetricMetadata } from "@/types/metrics/metadata"

import { getMetricTypeInfo } from "../hooks/useMetricTypeInfo"
import { getMetricType, type MetricTypeSource } from "./resolveThreshold"

type MetricFilterSource = MetricTypeSource & {
  metric_metadata?: Pick<
    MetricMetadata,
    "metadata_field_type" | "categories" | "units" | "additional_information"
  > | null
  getCategoricalOptions?: () => string[]
}

/** Declared filter values and units, independent of currently loaded results. */
export function getMetricFilterConfig(
  metric: MetricFilterSource,
  entry?: MetricDirectoryEntry,
) {
  const fieldType = metric.metric_metadata?.metadata_field_type
  const isMetadata = metric.metric_manager === "manager_metadata_field_metric"
  const isBoolean = isMetadata && fieldType === "BOOLEAN"
  const semanticType = getMetricType(metric, entry)
  const declaredOutput =
    entry?.output_type_source === "static" && entry.output_type
      ? entry.output_type
      : metric.output_type
  const instanceOutput = isMetadata
    ? fieldType === "STRING"
      ? "string"
      : ["BOOLEAN", "FLOAT", "NUMBER"].includes(fieldType ?? "")
        ? "float"
        : undefined
    : undefined
  const outputType = instanceOutput ?? declaredOutput
  const isBinary = isBoolean || semanticType === "binary"
  const categories = metric.metric_metadata?.categories?.length
    ? metric.metric_metadata.categories
    : getMetricTypeInfo(metric).categoryOptions
  const valueOptions = isBinary
    ? outputType === "float"
      ? [
          { value: "1", label: "Yes" },
          { value: "0", label: "No" },
        ]
      : [
          { value: "YES", label: "Yes" },
          { value: "NO", label: "No" },
          { value: "UNKNOWN", label: "Unknown" },
        ]
    : outputType === "string" && categories.length
      ? [...new Set(categories)].map((value) => ({ value, label: value }))
      : undefined
  return {
    outputType,
    valueOptions,
    unit: isBinary
      ? undefined
      : (entry?.base_unit ?? metric.metric_metadata?.units),
  }
}
